import 'C:\\Projects\\genkei\\zumeco\\static\\shared\\requireLogin.tsx.esbuild-plugin-linaria.css';
import 'C:\\Projects\\genkei\\zumeco\\static\\shared\\requireLogin.tsx.esbuild-plugin-windicss.css';
import { css, cx } from '@linaria/core';
import { render } from 'preact';
import { useState } from 'preact/hooks';
import type { CurrentFolderUser, ServiceUserAccount } from '../../server/src/models';
import { URL_API_DOODLE_GUEST_LOGIN, URL_API_FOLDER_GUEST_LOGIN } from '../../server/src/urls';
import { COLOR_SHADOW } from './colors';
import { HeaderTop } from './components/HeaderTop';
import { SubmitButton } from './components/SubmitButton';
import { i18n } from './i18n';
import { postJson, withProgressBar } from './utils';
const LoginForm = ({
  heading,
  className,
  onLogin
}: {
  heading: string;
  className?: string;
  onLogin: () => void;
}) => {
  const [errorMessage, setErrorMessage] = useState('');
  const [foldersOrDoodles, id] = location.pathname.replace('/quotation/', '/').replace(/^\//, '').split('/');
  console.log(foldersOrDoodles, id);
  const invitationCodeInputName = `invitation_${id}`;
  return <form className={className} onSubmit={event => {
    event.preventDefault();
    setErrorMessage('');
    const email = (event.currentTarget.email as HTMLInputElement).value;
    const invitationCode = (event.currentTarget[invitationCodeInputName] as HTMLInputElement).value;
    if (!email || !invitationCode) {
      return;
    }
    void withProgressBar(async () => {
      try {
        const response = await postJson(foldersOrDoodles === 'folders' ? URL_API_FOLDER_GUEST_LOGIN(id) : URL_API_DOODLE_GUEST_LOGIN(id), {
          email,
          invitationCode
        });
        if (response.ok) {
          return onLogin();
        }
        switch (response.status) {
          case 401:
            {
              const {
                code
              } = (await response.json()) as {
                code: keyof typeof i18n.unauthorized;
              };
              setErrorMessage(i18n.unauthorized[code] || i18n.errorOccurred);
              break;
            }
          default:
            setErrorMessage(i18n.errorOccurred);
            break;
        }
      } catch (error) {
        console.error(error);
        setErrorMessage(i18n.errorOccurred);
      }
    });
  }}>
      <h3 class="mb-5 text-lg" data-text={heading} children={heading} />
      {errorMessage && <p class="rounded-sm text-sm px-4 py-2 mb-5 border" style={{
      color: 'hsl(340, 100%, 50%)',
      background: 'hsl(340, 100%, 97%)'
    }}>
          {errorMessage}
        </p>}
      <div class="mui-textfield mui-textfield--float-label">
        <input type="email" name="email" autoComplete="email" placeholder="&nbsp;" required autofocus />
        <label>{i18n.email}</label>
      </div>
      <div class="mui-textfield mui-textfield--float-label">
        <input name={invitationCodeInputName} placeholder="&nbsp;" required />
        <label>{i18n.joinWithInvitationCode.invitationCode}</label>
      </div>
      <SubmitButton label={i18n.open} style={{
      width: '100%',
      marginTop: '16px',
      fontSize: 'inherit'
    }} />
    </form>;
};
export const requireLogin = (rootElement: HTMLElement, currentUser: ServiceUserAccount | CurrentFolderUser | undefined) => new Promise<void>(resolve => {
  const isFolder = location.pathname.startsWith('/folders/');
  render(<>
        <HeaderTop currentUser={currentUser} showsLoginLink />
        <div class="flex items-center justify-center h-full">
          <LoginForm heading={isFolder ? i18n.joinWithInvitationCode.folderHeading : i18n.joinWithInvitationCode.doodleHeading} onLogin={() => {
        rootElement.innerHTML = '';
        resolve();
      }} className={cx("l8m4cw7", isFolder && "lx807nu")} />
        </div>
      </>, rootElement);
});